import React, {useEffect, useState} from "react";
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import SellerLogoForm from "./SellerLogoForm";
import Popup from "../../../../component/Popup/Popup";
import SellerLogoDisplay from "./SellerLogoDisplay";
import axios from "axios";
import {ApiUrl} from "../../../../auth/authMethods";
import BasicLoader from "../../../../component/BasicLoader/BasicLoader";

export default function SellerLogo({participante, setLoadData}) {

    const [lgShow, setLgShow] = useState(false);

    const [loaded, setLoaded] = useState(false);
    const [logoVendedor, setLogoVendedor] = useState(null);

    const buttonText = <>
        <AddPhotoAlternateIcon fontSize="medium"/>
        &nbsp; Logo de Cliente
    </>;

    const title = "Gerenciar Logo de Cliente"

    const iconSpan = <>
        <AddPhotoAlternateIcon fontSize="large" id="icon-svg"/>
        <h3>{title}</h3>
    </>

    useEffect(() => {
        // Função para buscar a imagem do backend
        const fetchFoto = async () => {

            axios.get(`${ApiUrl}/seller-logo/${participante.id}`).then((response) => {
                setLogoVendedor(response.data);
                setLoaded(true);
            }).catch()

        };

        fetchFoto();
    }, [participante]);


    return <Popup
        buttonClass="dropdown-item"
        buttonText={buttonText}
        title={title}
        iconSpan={iconSpan}
        lgShow={lgShow}
        setLgShow={setLgShow}
    >
        <div style={{width: '80%', margin: '0 10%', textAlign: "center"}}>
            {loaded ?
                logoVendedor?.id ?
                    <SellerLogoDisplay
                        participante={participante}
                        setLoadData={setLoadData}
                        logoVendedor={logoVendedor}
                    />
                    :
                    <SellerLogoForm participanteId={participante?.id} setLoadData={setLoadData}/>
                :
                <BasicLoader />
            }

        </div>
    </Popup>
}